import { render, staticRenderFns } from "./SendConfirm.vue?vue&type=template&id=e942102e"
import script from "./SendConfirm.vue?vue&type=script&lang=js"
export * from "./SendConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports